import { useQuery } from "@tanstack/react-query";

import {
  type AutoRenewContent,
  autoRenewContentSchema,
  fallbackAutoRenewContent,
} from "@/services/cms";
import { fetchJSONFactory } from "@/utils/fetch-json";

const CMS_API = import.meta.env.VITE_CMS_API;
const fetchJSON = fetchJSONFactory(CMS_API);

export { type AutoRenewContent };

export const CMSQueryKey = ["cms"];

export function useAutoRenewContent() {
  return useQuery({
    queryKey: [...CMSQueryKey, "auto-renew-savings"],
    queryFn: async (): Promise<AutoRenewContent> => {
      try {
        const response = await fetchJSON<AutoRenewContent>(
          "api/globals/auto-renew-savings",
        );

        // Validate response with Zod
        const validatedContent = autoRenewContentSchema.parse(response);
        return validatedContent;
      } catch (error) {
        // Fallback content if CMS is not available or validation fails
        return fallbackAutoRenewContent;
      }
    },
  });
}
